import {Fragment, type ReactNode} from 'react'
import {clsx} from 'clsx'
import {SimpleListItem} from '@github-ui/simple-list-view/SimpleListItem'
import styles from './TaskListItem.module.css'

export interface TaskDescriptionProps {
  parts: ReactNode[]
  className?: string
}

export function TaskDescription({parts, className}: TaskDescriptionProps) {
  const filtered = parts.filter(part => part != null && part !== false && part !== '')
  return (
    <SimpleListItem.Description className={clsx(styles.itemDescription, className)}>
      {filtered.map((part, index) => (
        <Fragment key={index}>
          {index > 0 && <span> · </span>}
          {part}
        </Fragment>
      ))}
    </SimpleListItem.Description>
  )
}
